import React, { useState, useEffect, useCallback } from 'react';
import './Print.css'; // Import the CSS file

const Print = ({ navigation, route }) => {
  const { firstName, Name, AccountNo, AccountType, Recieved, PresentBalance, Phone, agentUserName } = route.params;
  const [pairedDevices, setPairedDevices] = useState([]);
  const [foundDs, setFoundDs] = useState([]);
  const [bleOpend, setBleOpend] = useState(false);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [boundAddress, setBoundAddress] = useState('');
  const [blueStatus, setBlueStatus] = useState('false');
  const collectionUrl2 = 'http://117.220.197.82:80/saved-detail/';

  // Blue Tooth printer
  const accountNo = AccountNo;
  const accountType = AccountType;
  const recieved = Recieved;
  const presentBalance = PresentBalance;
  const phone = Phone;
  const bank = "Bank";

  const Refresh = () => {
    navigation.navigate('Print',
      {
        firstName: firstName.toString(), Name: name.toString(),
        AccountNo: accountNo, AccountType: accountType.toString(),
        Recieved: recieved.toString(), PresentBalance: presentBalance.toString(),
        Phone: phone,
        agentUserName: agentUserName
      });
  }

  useEffect(() => {
    var myInterval = setInterval(checkBluetoothStatus, 5000);
    return () => clearInterval(myInterval);
  });

  const goCollect = () => {
    navigation.navigate('Collect', { firstName: firstName.toString(), agentUserName: agentUserName.toString() });
  }

  const gotoCollect = () => {
    if (window.confirm("Do you want to go to Collection Screen?\nDid you take print?")) {
      goCollect();
    }
  }

  const checkBluetoothStatus = () => {
    // Simulating bluetooth check
    setBleOpend(true);
    setLoading(false);
  }

  const setBluetoothStatus = () => {
    setBlueStatus("true");
  }

  const deviceAlreadPaired = useCallback(
    rsp => {
      var ds = null;
      if (typeof rsp.devices === 'object') {
        ds = rsp.devices;
      } else {
        try {
          ds = JSON.parse(rsp.devices);
        } catch (e) { }
      }
      if (ds && ds.length) {
        let pared = pairedDevices;
        if (pared.length < 1) {
          pared = pared.concat(ds || []);
        }
        setPairedDevices(pared);
      }
    },
    [pairedDevices],
  );

  const deviceFoundEvent = useCallback(
    rsp => {
      var r = null;
      try {
        if (typeof rsp.device === 'object') {
          r = rsp.device;
        } else {
          r = JSON.parse(rsp.device);
        }
      } catch (e) {
        // ignore error
      }

      if (r) {
        let found = foundDs || [];
        if (found.findIndex) {
          let duplicated = found.findIndex(function (x) {
            return x.address == r.address;
          });
          if (duplicated == -1) {
            found.push(r);
            setFoundDs(found);
          }
        }
      }
    },
    [foundDs],
  );

  const connect = row => {
    setLoading(true);
    // Simulating connection
    setTimeout(() => {
      setLoading(false);
      setBoundAddress(row.address);
      setName(row.name || 'UNKNOWN');
    }, 1000);
  };

  const unPair = address => {
    setLoading(true);
    // Simulating unpair
    setTimeout(() => {
      setLoading(false);
      setBoundAddress('');
      setName('');
    }, 1000);
  };

  const scanDevices = useCallback(() => {
    setLoading(true);
    // Simulating device scan
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [foundDs]);

  const scan = useCallback(() => {
    scanDevices();
  }, [scanDevices]);

  const printReceipt = async () => {
    let msg = "Message";
    try {
      let response = await fetch(collectionUrl2 + accountNo);
      let readSave = await response.json();
      var data_filter1 = [{ "AccountNo": "", "AccountType": "", "Balance": "", "OpenDate": "", "Phone": "", "Status": "", "AgentName": "" }];
      data_filter1 = readSave.filter(element => element.AccountNo === accountNo && element.AgentName === agentUserName);
      var len = readSave.length;
      if (data_filter1[len - 1]['AgentName'] === agentUserName) {
        msg = "Reciept No: " + data_filter1[len - 1].id + ", Dear " + data_filter1[len - 1].Name + "\n" + ", A/C No:" + data_filter1[len - 1].AccountNo + " , \nCredited Rs:" + data_filter1[len - 1].Recieved + "\nPresent Balance is Rs: " + data_filter1[len - 1].PresentBalance + "\nThank you " + firstName;
      }
    } catch (e) {
      console.log(e);
    }

    try {
      // Simulating print
      alert("Printing receipt:\n" + msg);
      navigation.navigate('Collect', { firstName: firstName.toString(), agentUserName: agentUserName.toString() });
    } catch {
      alert(msg);
    }
  };

  return (
    <div className="Print-container">
      <div className="Print-centerizedView">
        <div className="Print-authBox">
          <div className="Print-bluetoothStatusContainer">
            <span className={`Print-bluetoothStatus ${bleOpend ? 'Print-active' : 'Print-inactive'}`}>
              Bluetooth {bleOpend ? 'Active' : 'Non Active'}
            </span>
          </div>
          {!bleOpend && <div className="Print-bluetoothInfo">Please activate your bluetooth</div>}
          <div className="Print-BluetoothStatus">Printers List:</div>
          {boundAddress.length > 0 && (
            <div className="Print-itemList">
              <span>{name}</span>
              <span>{boundAddress}</span>
              <button onClick={() => unPair(boundAddress)} className="Print-unpairButton">
                Unpair
              </button>
            </div>
          )}
          {boundAddress.length < 1 && (
            <div className="Print-printerInfo">No printer connected yet</div>
          )}
          {bleOpend && <div className="Print-BluetoothStatus">Bluetooth connected</div>}

          {loading && <div className="Print-loading">Loading...</div>}
          <div className="Print-containerList">
            {pairedDevices.map((item, index) => {
              return (
                <div key={index} className="Print-itemList">
                  <span>{item.name}</span>
                  <span>{item.address}</span>
                  <button
                    onClick={() => connect(item)}
                    className={`Print-connectButton ${item.address === boundAddress ? 'Print-connected' : ''}`}
                  >
                    Connect
                  </button>
                </div>
              );
            })}
          </div>
          <div>
            <button className="Print-blueBtn" onClick={printReceipt}>
              Print Receipt
            </button>
            <button className="Print-pinkBtn" onClick={gotoCollect}>
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Print;